import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments"
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import ForgetPassword from "../pages/ForgetPassWord/";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import TagsReport from "../pages/TagsReport";
import UsersReport from "../pages/UsersReport";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault"
import CampaignsPhrase from "../pages/CampaignsPhrase";
import Subscription from "../pages/Subscription";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files";
import ToDoList from "../pages/ToDoList";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import empresa from "../pages/Empresa";
import Pauses from "../pages/Pauses";
import PausesReport from "../pages/PausesReport";
import UserRatingsReport from "../pages/UserRatingsReport";
import ReportsCentral from "../pages/ReportsCentral";
import CampaignWizard from "../pages/CampaignWizard";
import RevenueReport from "../pages/RevenueReport";

import documentacao from "../pages/documentacao";
import ForbiddenPage from "../components/ForbiddenPage";

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgetpsw" component={ForgetPassword} />
            
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/financeiro" component={Financeiro} isPrivate allowedProfiles={['admin']} />

                <Route exact path="/companies" component={Companies} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/" component={Dashboard} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/contacts/import" component={ContactImportPage} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/messages-api" component={MessagesAPI} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/settings" component={SettingsCustom} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/queues" component={Queues} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/pauses" component={Pauses} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/pauses/report" component={PausesReport} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/reports" component={Reports} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/tags-report" component={TagsReport} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/users-report" component={UsersReport} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/ratings-report" component={UserRatingsReport} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/reports-central" component={ReportsCentral} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/revenue-report" component={RevenueReport} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/announcements" component={Annoucements} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/documentacao" component={documentacao} isPrivate />
                <Route exact path="/empresa" component={empresa} isPrivate />
                <Route exact path="/forbidden" component={ForbiddenPage} isPrivate />

                <Route
                  exact
                  path="/phrase-lists"
                  component={CampaignsPhrase}
                  isPrivate
                  allowedProfiles={['admin', 'supervisor']}
                />
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                  allowedProfiles={['admin', 'supervisor']}
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                  allowedProfiles={['admin', 'supervisor']}
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/moments" component={ChatMoments} isPrivate allowedProfiles={['admin', 'supervisor']} />
                <Route exact path="/Kanban" component={Kanban} isPrivate />
                <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate allowedProfiles={['admin']} />
                <Route exact path="/allConnections" component={AllConnections} isPrivate allowedProfiles={['admin']} />
                <Route
                  exact
                  path="/subscription"
                  component={Subscription}
                  isPrivate
                />
                {showCampaigns && (
                  <>
                    <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                    <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                    <Route exact path="/campaigns" component={Campaigns} isPrivate />
                    <Route exact path="/campaign-wizard" component={CampaignWizard} isPrivate />
                    <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                    <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-center" autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
